// Location Module
export const LOCATION_SET = 'LOCATION_SET'
// Device Module
export const DEVICE_SET = 'DEVICE_SET'
export const DEVICE_ROOM_SET = 'DEVICE_ROOM_SET'
export const DEVICE_STATUS_SET = 'DEVICE_STATUS_SET'
export const DEVICE_MOVE_RIGHT = 'DEVICE_MOVE_RIGHT'
export const DEVICE_MOVE_LEFT = 'DEVICE_MOVE_LEFT'
export const DEVICE_REMOVE = 'DEVICE_REMOVE'

// Client Module
export const CLIENT = {
  CLIENT_SET: 'CLIENT_SET',
  SET_CLIENT_CONFIG: 'SET_CLIENT_CONFIG',
  RESTORE_CLIENT_CONFIG: 'RESTORE_CLIENT_CONFIG',
  SET_CLIENT_ID: 'SET_CLIENT_ID',
  SET_CLIENT_ADMIN: 'SET_CLIENT_ADMIN'
}

export const ROOM_SET = 'ROOM_SET'
export const ROOM_BEHAVIOR_SET = 'ROOM_BEHAVIOR_SET'
export const COMBINED_ROOM_BEHAVIOR_SET = 'COMBINED_ROOM_BEHAVIOR_SET'
export const ROOM_NAME = 'ROOM_NAME'
export const ROOM_DEVICES = 'ROOM_DEVICES'
export const ROOM_DEVICES_BLOCK_ACCESS_SET = 'ROOM_DEVICES_BLOCK_ACCESS_SET'

export const EQUIPMENT_SET = 'EQUIPMENT_SET'

export const EQUIPMENT_SET_CLIENT = 'EQUIPMENT_SET_CLIENT'
export const EQUIPMENT_MOVE_LEFT = 'EQUIPMENT_MOVE_LEFT'
export const EQUIPMENT_MOVE_RIGHT = 'EQUIPMENT_MOVE_RIGHT'
export const EQUIPMENT_REMOVE = 'EQUIPMENT_REMOVE'

export const CALENDAR_SET = 'CALENDAR_SET'

export const UI_CONFIG_SET = 'UI_CONFIG_SET'

export const CONTACT_SET = 'CONTACT_SET'

export const REPORT_CONFIG_SET = 'REPORT_CONFIG_SET'
export const REPORT_LOAD = 'REPORT_LOAD'
export const REPORT_ADD_CONFIG = 'REPORT_ADD_CONFIG'
export const REPORT_EDIT_CONFIG = 'REPORT_EDIT_CONFIG'
export const REPORT_DELETE_CONFIG = 'REPORT_DELETE_CONFIG'

// Booking Module
export const BOOKING = {
  SET_LOCATION_SELECTED: 'SET_LOCATION_SELECTED',
  SET_EQUIPMENT_SELECTED: 'SET_EQUIPMENT_SELECTED',
  SET_PEOPLE_SELECTED: 'SET_PEOPLE_SELECTED',
  SET_DATE: 'SET_DATE',
  SET_DURATION: 'SET_DURATION',
  SET_START_TIME: 'SET_START_TIME',
  SET_END_TIME: 'SET_END_TIME',
  SET_RESULT: 'SET_RESULT',
  RESET_RESULT: 'RESET_RESULT',
  SET_START_SELECTED: 'SET_START_SELECTED',
  SET_END_SELECTED: 'SET_END_SELECTED',
  SET_ROOM_SELECTED: 'SET_ROOM_SELECTED',
  SET_SELECTED_ROOMS: 'SET_SELECTED_ROOMS',
  PUSH_ROOM: 'PUSH_ROOM',
  REMOVE_ROOM: 'REMOVE_ROOM',
  SET_BOOKINGS: 'SET_BOOKINGS',
  END_DATE_SEARCHED: 'END_DATE_SEARCHED',
  PUSH_LOCATION_SELECTED: 'PUSH_LOCATION_SELECTED',
  SET_LOADING_STATUS: 'SET_LOADING_STATUS',
  INCREASE_OFFSET: 'INCREASE_OFFSET',
  CLEAR_ALL: 'CLEAR_ALL',
  SET_TOTAL_RESULT: 'SET_TOTAL_RESULT',
  SET_DATE_RESULT: 'SET_DATE_RESULT',
  INCREASE_ACTUALVIEW: 'INCREASE_ACTUALVIEW',
  DECREASE_ACTUALVIEW: 'DECREASE_ACTUALVIEW',
  PUSH_EVENTS_ATTENDEES: 'PUSH_EVENTS_ATTENDEES',
  REMOVE_EVENTS_ATTENDEE: 'REMOVE_EVENTS_ATTENDEE',
  PUSH_ATTENDEES: 'PUSH_ATTENDEES',
  REMOVE_ATTENDEE: 'REMOVE_ATTENDEE',
  SET_ATTENDEES: 'SET_ATTENDEES',
  ADD_EVENTS_ATTENDEES: 'ADD_EVENTS_ATTENDEES',
  SET_ATTENDEE_EVENTS_ERROR: 'SET_ATTENDEE_EVENTS_ERROR',
  CLEAR_ATTENDEES: 'CLEAR_ATTENDEES',
  SET_SLOT_SELECTED: 'SET_SLOT_SELECTED',
  PUSH_USER_OWNER: 'PUSH_USER_OWNER',
  REMOVE_USER_OWNER: 'REMOVE_USER_OWNER',
  SET_USER_OWNER: 'SET_USER_OWNER',
  CLEAR_USER_OWNER: 'CLEAR_USER_OWNER',
  SET_EVENT: 'SET_EVENT',
  SET_SELECTED_SERVICES: 'SET_SELECTED_SERVICES',
  SET_EVENT_ERROR: 'SET_EVENT_ERROR',
  SET_EVENT_ERROR_DATA: 'SET_EVENT_ERROR_DATA',
  SET_COST_CENTERS: 'SET_COST_CENTERS',
  PUSH_COST_CENTER: 'PUSH_COST_CENTER',
  REMOVE_COST_CENTER: 'REMOVE_COST_CENTER',
  CLEAR_COST_CENTER: 'CLEAR_COST_CENTER',
}

export const PAGE_CONTAINER = {
  SET_MENU_SELECTED: 'SET_MENU_SELECTED',
  SET_MENU_FOCUSED: 'SET_MENU_FOCUSED',
  SHOW_MENU: 'SHOW_MENU',
  SHOW_ADM: 'SHOW_ADM'
}

export const AUTH = {
  SET_USER: 'SET_USER',
  SET_AUTHENTICATED: 'SET_AUTHENTICATED'
}

export const GLOBAL = {
  SET_LOADING: 'SET_LOADING',
  SET_WINDOW_WIDTH: 'SET_WINDOW_WIDTH',
  SET_COMPANY_DATA: 'SET_COMPANY_DATA',
  SET_TOUCH_USED: 'SET_TOUCH_USED',
  SET_CLIENT_QUOTA: 'SET_CLIENT_QUOTA',
  SET_CLIENT_UI_CONFIGURATION: 'SET_CLIENT_UI_CONFIGURATION'
}

export const BUILDING = {
  SET_RESULT: 'SET_RESULT',
  RESET_RESULT: 'RESET_RESULT',
  SHOW_EVENTS: 'SHOW_EVENTS'
}

export const MANAGER_SET = 'MANAGER_SET'

export const PROTECT_SET = 'PROTECT_SET'

export const CLEAR_ALL = 'CLEAR_ALL'

export const SETTING_SET = 'SETTING_SET'

export const PROTECT = {
  SET_BOOKINGS: 'SET_BOOKINGS',
  REMOVE_USER: 'REMOVE_USER',
  PUSH_USER: 'PUSH_USER',
  SET_USER: 'SET_USER'
}

// Service Desk Module
export const SERVICE_DESK = {
  SET_SERVICES: 'SET_SERVICES',
  SET_REQUESTS: 'SET_REQUESTS',
  SET_SUPPLIERS: 'SET_SUPPLIERS',
  SET_DATE: 'SET_DATE',
  AUDIT_LOG_SET: 'AUDIT_LOG_SET',
  PUSH_USER: 'PUSH_USER',
  REMOVE_USER: 'REMOVE_USER',
  SET_USER: 'SET_USER'
}

export const ADMINISTRATOR = {
  SET_ADMINISTRATOR: 'SET_ADMINISTRATOR',
  PUSH_USER: 'PUSH_USER',
  REMOVE_USER: 'REMOVE_USER'
}

export const SUPPLIER = {
  SET_SUPPLIERS: 'SET_SUPPLIERS',
  SET_ITEMS: 'SET_ITEMS',
  SET_ITEM_TYPE: 'SET_ITEM_TYPE',
  SET_NAME: 'SET_NAME'
}

export const COLLABORATOR_GROUPS = {
  SET_GROUPS: 'SET_GROUPS',
  SET_USERS: 'SET_USERS',
  PUSH_USERS: 'PUSH_USERS',
  REMOVE_USERS: 'REMOVE_USERS',
  SET_ROOM_COLLABORATORS_GROUPS: 'SET_ROOM_COLLABORATORS_GROUPS',
  GROUP_REMOVE: 'GROUP_REMOVE'
}

export const REPORT = {
  SET_IS_DOWNLOADING_FILE: 'SET_IS_DOWNLOADING_FILE',
  SET_STARTDATE: 'SET_STARTDATE',
  SET_ENDDATE: 'SET_ENDDATE',
  SET_LOCATIONS: 'SET_LOCATIONS',
  CLEAR_LOCATIONS: 'CLEAR_LOCATIONS',
  SELECT_LOCATION: 'SELECT_LOCATION',
  CLEAR_LOCATION: 'CLEAR_LOCATION',
  SELECT_OWNER: 'SELECT_OWNER',
  REMOVE_OWNER: 'REMOVE_OWNER',
  CLEAR_OWNER: 'CLEAR_OWNER',
  SELECT_EVENT_STATUS: 'SELECT_EVENT_STATUS',
  CLEAR_EVENT_STATUS: 'CLEAR_EVENT_STATUS',
  SET_EVENT_REPORT: 'SET_EVENT_REPORT',
  CLEAR_EVENT_REPORT: 'CLEAR_EVENT_REPORT'
}
